"use client";

import React, { useState, useEffect, useCallback } from "react";
import { useRouter } from "next/navigation";

import { ClickAwayListener } from "@mui/material";

import Components from "@/components";
import Icons from "@/assets/icons";
import sk from "@/skeletons";
import "./drop-menu.scss";
import api from "@/api";
import Image from "next/image";

function Notification({ close }) {
  const [activeLink, setActiveLink] = useState("viewall");
  const [notifList, setNotifList] = useState(null);
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const getNotifications = useCallback(async () => {
    setLoading(true);
    if (activeLink === "viewall") {
      const res = await api.getNotifications();
      if (res.data?.success === 200) setNotifList(res?.data?.result);
      // console.log("res is: ", res?.data?.result);
    } else if (activeLink === "mentions") {
      const res = await api.getMentions();
      if (res.data?.success === 200) setNotifList(res?.data?.result);
    }
    setLoading(false);
  }, [activeLink]);

  useEffect(() => {
    getNotifications();
  }, [getNotifications]);

  return (
    <ClickAwayListener onClickAway={close}>
      <div className="ntf-cont">
        <header className="ntf-header">
          <div>
            Notifications
            <svg
              width="20"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              onClick={close}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.3495 9.99858L19.5103 2.85447C19.8238 2.54089 20 2.11558 20 1.67211C20 1.22864 19.8238 0.80333 19.5103 0.489749C19.1967 0.176168 18.7714 0 18.3279 0C17.8844 0 17.4591 0.176168 17.1455 0.489749L10.0014 7.65052L2.85731 0.489749C2.54373 0.176168 2.11842 -3.30411e-09 1.67495 0C1.23148 3.30411e-09 0.806172 0.176168 0.492591 0.489749C0.17901 0.80333 0.00284199 1.22864 0.00284199 1.67211C0.00284199 2.11558 0.17901 2.54089 0.492591 2.85447L7.65336 9.99858L0.492591 17.1427C0.336506 17.2975 0.212618 17.4817 0.128073 17.6846C0.0435283 17.8875 0 18.1052 0 18.3251C0 18.5449 0.0435283 18.7626 0.128073 18.9655C0.212618 19.1684 0.336506 19.3526 0.492591 19.5074C0.647402 19.6635 0.831585 19.7874 1.03452 19.8719C1.23745 19.9565 1.45511 20 1.67495 20C1.89479 20 2.11245 19.9565 2.31538 19.8719C2.51832 19.7874 2.7025 19.6635 2.85731 19.5074L10.0014 12.3466L17.1455 19.5074C17.3003 19.6635 17.4845 19.7874 17.6875 19.8719C17.8904 19.9565 18.1081 20 18.3279 20C18.5477 20 18.7654 19.9565 18.9683 19.8719C19.1713 19.7874 19.3554 19.6635 19.5103 19.5074C19.6663 19.3526 19.7902 19.1684 19.8748 18.9655C19.9593 18.7626 20.0028 18.5449 20.0028 18.3251C20.0028 18.1052 19.9593 17.8875 19.8748 17.6846C19.7902 17.4817 19.6663 17.2975 19.5103 17.1427L12.3495 9.99858Z"
                fill="var(--text-color)"
              />
            </svg>
          </div>
          <nav className="ntf-nav">
            <button
              onClick={() => setActiveLink("viewall")}
              className={activeLink === "viewall" ? "nav-active" : ""}
            >
              View all
            </button>
            <button
              onClick={() => setActiveLink("mentions")}
              className={activeLink === "mentions" ? "nav-active" : ""}
            >
              Mentions
            </button>
          </nav>
        </header>
        <section className={"ntf-box"}>
          {!loading ? (
            notifList && notifList?.data?.length ? (
              notifList?.data?.map((notif, i) => (
                <Components.NotificationItem key={i} item={notif} />
              ))
            ) : (
              <div className={"ntf-empty-box"}>
                <Image
                  src={Icons.Notification}
                  alt="notification-icon"
                  width={50}
                  height={50}
                />
                <span>
                  {activeLink === "viewall" ? "No Notification" : "No Mentions"}
                </span>
              </div>
            )
          ) : (
            <sk.RowCardSkeleton number={10} type="sk-notification" />
          )}
        </section>
        <footer className="ntf-footer">
          <button
            className="footer-btn-2"
            onClick={() => router.push("/notifications")}
          >
            View all
          </button>
        </footer>
      </div>
    </ClickAwayListener>
  );
}

export default Notification;
